module.exports = __webpack_public_path__ + "static/media/arrowRight.521e18c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrowRight.svg
// module id = 1151
// module chunks = 0